import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as api from "@/services/api";
export const Status = {
  IDLE: "Idle",
  CREATING: "Creating",
  CREATED: "Created",
  DELETING: "Deleting",
  DELETED: "Deleted",
  UPDATING: "Updateing",
  UPDATED: "Updated",
  PREVIEWING: "Previewing",
  CONFIRMED: "Confirmed",
};

export const StatusLogin = {
  LOGGED_IN: "Logged in",
  LOGGED_OUT: "Logged out",
  LOGGED_FAILED: "Logged Failed",
};
export const SORT = {
  STATUS: 0,
  ASC: 1,
  DESC: 2,
};

const initialState = {
  status: Status.IDLE,
  statusLogin: StatusLogin.LOGGED_OUT,
  modalAnnouncement: undefined,
  sortFilter: SORT.STATUS,
};

export const createAnnouncement = createAsyncThunk(
  "config/createAnnouncement",
  async (announcement) => {
    delete announcement.name;
    const announcementResponse = await api.create(
      `/announcement`,
      announcement
    );
    return {
      announcementResponse,
    };
  }
);

export const updateAnnouncement = createAsyncThunk(
  "config/updateAnnouncement",
  async ({ id, differences }) => {
    const announcementResponse = await api.update(
      `/announcement`,
      id,
      differences
    );
    return {
      announcementResponse,
    };
  }
);

export const confirmAnnouncement = createAsyncThunk(
  "config/confirmAnnouncement",
  async (announcement) => {
    const body = { isPreview: false };
    const announcementResponse = await api.update(
      `/announcement`,
      announcement.id,
      body
    );
    return {
      announcementResponse,
    };
  }
);

export const deleteAnnouncement = createAsyncThunk(
  "config/deleteAnnouncement",
  async (announcement) => {
    const announcementResponse = await api.remove(
      `/announcement`,
      announcement.id
    );
    return {
      announcementResponse,
    };
  }
);

export const uploadFile = createAsyncThunk(
  "config/uploadFile",
  async ({ fileName, file, type, size }) => {
    const response = await api.create(`/reportAutofill`, { file });
    return {
      response,
      fileName,
      file,
      type,
      size,
    };
  }
);

const slice = createSlice({
  name: "admin",

  initialState,
  reducers: {
    setStatus(state, action) {
      const { status } = action.payload;
      state.status = status;
    },
    setStatusLogin(state, action) {
      const { status } = action.payload;
      state.statusLogin = status;
    },
    setSortFilter(state, action) {
      const { sort } = action.payload;
      if (sort === state.sortFilter) {
        state.sortFilter = SORT.STATUS;
      } else {
        state.sortFilter = sort;
      }
    },
  },
  extraReducers: {
    [createAnnouncement.pending](state) {
      state.status = Status.CREATING;
    },

    [createAnnouncement.fulfilled](state, action) {
      state.status = Status.CREATED;
    },

    [createAnnouncement.rejected](state) {
      state.status = Status.FAILED;
    },
    [deleteAnnouncement.pending](state) {
      state.status = Status.DELETING;
    },

    [deleteAnnouncement.fulfilled](state, action) {
      state.status = Status.DELETED;
    },

    [deleteAnnouncement.rejected](state) {
      state.status = Status.FAILED;
    },
    [updateAnnouncement.pending](state) {
      state.status = Status.UPDATING;
    },

    [updateAnnouncement.fulfilled](state, action) {
      state.status = Status.UPDATED;
    },

    [updateAnnouncement.rejected](state) {
      state.status = Status.IDLE;
    },
    [confirmAnnouncement.pending](state) {
      state.status = Status.UPDATING;
    },

    [confirmAnnouncement.fulfilled](state, action) {
      state.status = Status.CONFIRMED;
    },

    [confirmAnnouncement.rejected](state) {
      state.status = Status.IDLE;
    },
    [uploadFile.pending](state) {
      state.status = Status.CREATING;
    },
    [uploadFile.fulfilled](state, action) {
      return { ...state, status: Status.SUCCESS };
    },
    [uploadFile.rejected](state, action) {
      state.status = Status.ERROR;
    },
  },
});

export default slice.reducer;

export const { setStatus, setStatusLogin, setSortFilter } = slice.actions;

export const selectModalAnnouncement = (state) => state.admin.modalAnnouncement;

export const selectStatus = (state) => state.admin.status;

export const selectStatusLogin = (state) => state.admin.statusLogin;

export const selecSortFilter = (state) => state.admin.sortFilter;
